var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2051 18.8373V17.2049C14.6922 16.9228 15.8631 16.0682 15.8716 14.5042C15.8716 12.3504 14.0255 11.6069 12.2991 11.1624C10.5727 10.718 10.0172 10.2479 10.0172 9.53003C10.0172 8.70956 10.7864 8.12839 12.0684 8.12839C13.4187 8.12839 13.923 8.77793 13.9657 9.7266H15.6408C15.5896 8.41897 14.7947 7.2139 13.2051 6.82931V5.16272H10.9231V6.81221C9.45311 7.12844 8.26513 8.08566 8.26513 9.55567C8.26513 11.3077 9.71806 12.1795 11.8376 12.6923C13.7435 13.1452 14.1196 13.8119 14.1196 14.5212C14.1196 15.0426 13.7435 15.8802 12.0684 15.8802C10.5043 15.8802 9.88899 15.1793 9.80352 14.2819H8.12839C8.2224 15.94 9.46166 16.8801 10.9231 17.1878V18.8373H13.2051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.dceab6d7195e12aea5203aaab2b9a651.svg";
export { ForwardRef as ReactComponent };